import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-713ad6fb"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "section evidence" }
const _hoisted_2 = { class: "evidence__list" }

import SectionHeading from "@/components/SectionHeading.vue";
import { evidenceItems } from "@/data/profile";

export default /*#__PURE__*/_defineComponent({
  __name: 'EvidenceSection',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createVNode(SectionHeading, {
      eyebrow: "Praxis",
      title: "Wo diese Arbeitsweise praktisch wird.",
      description: "Konkrete Situationen, in denen meine Arbeit greift: Aufbau, Architektur, Führung, Betrieb und KI-Qualität."
    }),
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(evidenceItems), (item) => {
        return (_openBlock(), _createElementBlock("article", {
          key: item.title
        }, [
          _createElementVNode("span", null, _toDisplayString(item.label), 1),
          _createElementVNode("h3", null, _toDisplayString(item.title), 1),
          _createElementVNode("p", null, _toDisplayString(item.context), 1),
          _createElementVNode("strong", null, _toDisplayString(item.outcome), 1)
        ]))
      }), 128))
    ])
  ]))
}
}

})